import AlBeefreeEditorController from './controller';
import template from './component.tpl.html';

angular
    .module('festzelt-os.modules.templates')
    .component('alBeefreeEditor', {
        bindings: {
            startTemplate: '<',
            onEditorReady: '&',
            onSave: '&',
            saveCallback: '=',
            contentDialogs: '<'
        },
        controller: AlBeefreeEditorController,
        controllerAs: 'vm',
        templateUrl: template
    });



// WEBPACK FOOTER //
// ./src/app/modules/templates/components/al-beefree-editor/component.js